import { Box } from '@branch-messenger/willow-ui'
import { BranchLogo } from '@branch-messenger/willow-ui/icons'
import { useMatch } from '@tanstack/react-router'
import { Fragment } from 'react'

import { TanstackButtonLink } from '@/components/menu-button'
import { useOrg } from '@/selectors/organization'

import { OrgImage } from '../styles'

export const OrgLogo = () => {
  const authenticatedRoute = useMatch({
    from: '/_authenticated',
    shouldThrow: false,
  })

  const {
    data: { orgInfo },
  } = useOrg()

  const logoUrl = orgInfo?.logo_url

  const LogoContainer = authenticatedRoute ? TanstackButtonLink : Fragment
  return (
    <LogoContainer
      {...(authenticatedRoute
        ? {
            variant: 'link',
            to: '/account',
            style: { border: 'none' },
          }
        : {})}
    >
      <Box $display="flex">
        {logoUrl ? (
          <OrgImage src={logoUrl} alt="org_logo" />
        ) : (
          <BranchLogo height={40} width={0} style={{ width: 'auto' }} />
        )}
      </Box>
    </LogoContainer>
  )
}
